import Auth from "shared/@auth";
import toast from "react-hot-toast";
import { useQuery, useMutation, useQueryClient } from "react-query";

export const useCommittees = (status) => {
  const { makeAuthedRequest } = Auth.useContainer();

  const fetchData = async () => {
    const data = makeAuthedRequest(`management-team/committees/${status}`)
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const json = await res.json();
          throw new Error(json.message);
        }
      })
      .then((json) => {
        return json;
      })
      .catch((err) => {
        console.error(err);
      });
    return data;
  };

  const { data, isLoading, isError, error } = useQuery(status, fetchData);

  return { data, isLoading, isError, error };
};

export const useCommitteeStatus = (status) => {
  const { makeAuthedRequest } = Auth.useContainer();
  const queryClient = useQueryClient();

  const changeCommitteeStatus = async (id) => {
    return makeAuthedRequest("management-team/committee/status/update", {
      method: "put",
      body: JSON.stringify({
        _id: id,
        status: status,
      }),
    });
  };

  const { mutate } = useMutation(changeCommitteeStatus, {
    onSuccess: async () => {
      queryClient.invalidateQueries("archived");
      queryClient.invalidateQueries("current");

      try {
        await Promise.all([
          queryClient.refetchQueries("current", { active: false, exact: true }),
          queryClient.refetchQueries("archived", {
            active: false,
            exact: true,
          }),
        ]);
      } catch (e) {
        console.warn("Refetch committees failed", e);
      }
      toast.success(
        status === "Archived"
          ? "Committee Archived"
          : status === "Current"
          ? "Committee Unarchived"
          : "Committee Deleted"
      );
    },
    onError: (err) => {
      console.error(err);
    },
  });

  return mutate;
};

export const useCreateCommittee = () => {
  const { makeAuthedRequest } = Auth.useContainer();
  const queryClient = useQueryClient();

  const createCommittee = async (committee) => {
    return makeAuthedRequest("management-team/committee/add", {
      method: "post",
      body: JSON.stringify(committee),
    });
  };

  const { mutate } = useMutation(createCommittee, {
    onSuccess: (data) => {
      queryClient.invalidateQueries("current");
      toast.success("Added Committee");
    },
    onError: (err) => {
      console.error(err);
    },
  });

  return mutate;
};

export const useEditCommittee = () => {
  const { makeAuthedRequest } = Auth.useContainer();
  const queryClient = useQueryClient();

  const editCommittee = async (committee) => {
    return makeAuthedRequest("management-team/committee/update", {
      method: "put",
      body: JSON.stringify(committee),
    });
  };

  const { mutate } = useMutation(editCommittee, {
    onSuccess: () => {
      queryClient.invalidateQueries("archived");
      queryClient.invalidateQueries("current");
      toast.success("Edited Committee");
    },
    onError: (err) => {
      console.error(err);
    },
  });

  return mutate;
};
